import { useEffect, useState } from 'react';

import { Route, Routes, BrowserRouter, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import SideBar from './sidebar';
import LoadingPet from './shared/LoadingPet';
import Plan from './plan';
import Login from './login'
import Page from './page';
import Terms from './terms';
import Thanks from './thanks';
// import Home from './home';
import Conversation from './conversation';
import Chat from './chat';
import Conf from './conf';
import Pronouncer from './pronouncer';
import Journey from './journey';
import ProgressPage from './progress';
import SharePage from './progress/SharePage';
import EnglishMindmaps from './englishmindmaps';
import OnboardingModal from './onboarding/OnboardingModal';
import BlogModule from './blog';
import { isMobile } from '../libs/platform';
import { initNative } from '../libs/native';
import './style.css';

import http from '../libs/http';
import alert from '../libs/alert';

function GaPageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-R4N8N77J9Y', { page_path: location.pathname + location.search });
    }
  }, [location]);
  return null;
}

const DEFAULT_USER_STATE = { token: null, planId: null };

function App() {
  const [user, setUser] = useState(DEFAULT_USER_STATE);
  const [loading, setLoading] = useState(true);

  async function load() {
    const storage: any = localStorage.getItem('user');
    if (!storage) return;
    
    let payload = JSON.parse(storage);
    if (!payload || !payload.token || !payload.email) return;
    payload = await isFounder(payload);

    setUser(payload);
  }

  async function isFounder(user: any): Promise<any> {
    const url = `${process.env.REACT_APP_API_URL}/api/v1/user/medals`;
    const headers = { Authorization: user.token };
    const response = await http.get(url, headers);

    if (response.error === 'Token não autorizado!') {
      alert.warn('Ops! Sessão expirada, logue novamente.');
      return { token: null };
    }

    if (!response || !response.length) {
      return user;
    };

    if (response.find((el: any) => el.medalId == 1)) {
      return {
        ...user,
        isFounder: true
      };
    }

    return user;
  }
  
  useEffect(() => {
    // Minimum 2.5 seconds loading to show the pet animation
    const minLoadTime = new Promise(resolve => setTimeout(resolve, 3000));

    Promise.all([load(), minLoadTime, initNative()]).then(() => setLoading(false));
  }, []);

  function Router() {
    if (loading) return (
      <div className="Chat-initial-loading" style={{ minHeight: '60vh' }}>
        <LoadingPet size="large" />
      </div>
    );

    if (!user.token) {
      // Mobile (Android/iOS): first screen = Login. Web: first screen = landing.
      return (
        <Routes>
          {isMobile ? (
            <>
              <Route Component={() => <Login setUser={setUser}/>} path="/" />
              <Route Component={() => <Login setUser={setUser}/>} path="/login" />
              <Route Component={() => <Page setUser={setUser}/>} path="/landing" />
            </>
          ) : (
            <>
              <Route Component={() => <Page setUser={setUser}/>} path="/" />
              <Route Component={() => <Login setUser={setUser}/>} path="/login" />
            </>
          )}
          <Route Component={() => <Terms />} path="/termos" />
          <Route Component={() => <Thanks />} path="/obrigado" />
        </Routes>
      )
    }

    const handler = (Component: any) => <Component user={user} setUser={setUser}/>;

    return (
      <>
        <Routes>
          <Route Component={() => handler(Conversation)} path="/" />
          <Route Component={() => handler(Journey)} path="/jornada" />
          <Route Component={() => handler(Conversation)} path="/conversacao" />
          {!isMobile && <Route Component={() => handler(Plan)} path="/planos" />}
          <Route Component={() => handler(Chat)} path="/chat" />
          <Route Component={() => handler(Pronouncer)} path="/pronunciador" />
          <Route Component={() => handler(EnglishMindmaps)} path="/mapas-mentais" />
          <Route Component={() => handler(ProgressPage)} path="/progresso" />
          <Route Component={() => handler(SharePage)} path="/compartilhar" />
          <Route Component={() => handler(Conf)} path="/perfil" />
        </Routes>
        <SideBar user={user} setUser={setUser}/>
        <OnboardingModal />
      </>
    )
  }

  return (
    <BrowserRouter>
      <GaPageViewTracker />
      <Routes>
        <Route path="/blog/*" element={<BlogModule />} />
        <Route path="*" element={
          <div className="App">
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
            <Router/>
          </div>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
